import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';

import { PatientReferral } from './__generated__/patient-referral-graphql.service.types';

@Injectable({ providedIn: 'root' })
export class PatientReferralGraphQL extends Query<PatientReferral> {
  document = gql`
    query PatientReferral {
      patient {
        referral {
          bannerAlertKey
          bannerText
          messageBody
          messageSubject
          messageUrl
          pageAction
          pageBody
          pageHeader
          showBanner
        }
      }
    }
  `;
}
